export const toolTipFlickerFix = {
  'svg > g > g:last-child': { 'pointer-events': 'none' },
}
